import {type Operation} from '@apollo/client';

// Marks a re-issued request as a retry so the backend can split its
// graphql.operation.{success,failed} metrics into retry vs first-attempt
// traffic (see gorilla's relay handler).
export const RETRY_ATTEMPT_HEADER = 'x-wandb-retry-attempt';

// Why a request was (re-)issued, so the backend can decompose operation
// metrics across ALL the re-issue layers, not just RetryLink. First attempts
// stay unstamped — the backend defaults a missing header to "initial", which
// keeps the header off the vast majority of traffic.
export const REQUEST_CAUSE_HEADER = 'x-wandb-request-cause';

export type RequestCause =
  | 'retry' // RetryLink re-issued after a retryable network error
  | 'error-refetch' // panel machinery re-fetched after a fetch error
  | 'incomplete-refetch' // follow-up fetch for runs the server marked incomplete
  | 'poll'; // periodic poll-loop re-issue

// Context fragment for apollo query calls: {...otherContext, ...requestCauseContext(cause)}.
export const requestCauseContext = (
  cause: RequestCause | undefined
): {headers?: {[key: string]: string}} =>
  cause ? {headers: {[REQUEST_CAUSE_HEADER]: cause}} : {};

export const stampRetryHeader = (
  operation: Operation,
  attempt: number
): void => {
  operation.setContext(
    ({headers = {}}: {headers?: {[key: string]: string}}) => ({
      headers: {
        ...headers,
        [RETRY_ATTEMPT_HEADER]: String(attempt),
        [REQUEST_CAUSE_HEADER]: 'retry',
      },
    })
  );
};
